import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import LandingPage from './components/LandingPage';
import Navbar from './components/Navbar';
import Project1 from './components/Project1';
import Project2 from './components/Project2';
import Team from './components/Team';
import Contact from './components/Contact';

const AppRouter: React.SFC<{}> = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route path='/projects' element={<Project1 />} />
        <Route path='/projects-webdesign' element={<Project2 />} />
        <Route path='/team' element={<Team />} />
        <Route path='/contact' element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
